import lazyLoading from './lazyLoading'

export default {
  name: 'Connector Info',
  path: '/connector',
  redirect: '/connector/info',
  meta: {
    icon: 'fas fa-cube',
    expanded: false
  },
  component: lazyLoading('connectorInfo', true),
  children: [
    {
      'name': 'Connector Health',
      'path': 'info',
      'meta': {
        'label': 'Connector Health'
      },
      'component': lazyLoading('connectorInfo/ConnectorList')
    }
  ]
}



// WEBPACK FOOTER //
// ./client/store/modules/menu/connectorInfo.js